import {useQuery} from "@tanstack/react-query";
import FileSaver from "file-saver";
import {useEffect} from "react";
import {getRetailLocationsToCSV} from "../services/RetailLocationService";
import {useLogout} from "./useLogout";

export function useRetailLocationDownloadCsv(
    {
        businessUnitCode,
        active,
        selectFitEbsCodeIds,
        selectFitCategoryIds,
        filterColumn,
        filterValue,
        filterOperator,
        searchString,
    },
    enabled = true
) {
    const logout = useLogout();
    const includeInactive = active !== true;
    const inactiveOnly = active === false;
    const {data, isError, error, refetch, isFetching} = useQuery({
        queryKey: [
            "downloadRetailLocationsCsv",
            businessUnitCode,
            active,
            selectFitEbsCodeIds,
            selectFitCategoryIds,
            filterColumn,
            filterValue,
            filterOperator,
            searchString
        ],
        queryFn: async () => {
            const response = await getRetailLocationsToCSV({
                businessUnitCode,
                includeInactive,
                inactiveOnly,
                selectFitEbsCodeIds,
                selectFitCategoryIds,
                filterColumn,
                filterValue,
                filterOperator,
                searchString: searchString ? searchString?.trim() : "",
            });
            const blob = new Blob([response.data], {type: "text/csv;charset=utf-8;"});
            FileSaver.saveAs(blob, "MFE-Admin-Portal-RetailLocations.csv");
            return response;
        },
        enabled: enabled,
        retry: false,
    });
    useEffect(() => {
        if (isError && error.response && error.response.status) {
            if (error.response.status === 401) {
                logout();
            }
        }
    }, [isError, error]);

    return [refetch, isFetching, isError, error];
}
